import React, { useCallback } from 'react';
import i18n from 'asset/translation';
import Dashboard from 'domain/entity/dashboard';
import { useNavigation } from 'adapter/in/common/hooks/useNavigation';
import { StyledSpan } from 'adapter/in/common/components/HomeTable/style';

export const useDashboardsNameColumn = (order: { columnKey: string; order: string } | undefined) => {
    const { navigationPush } = useNavigation();
    const handleOnDashboardClick = useCallback((dashboardId: string) => navigationPush(`${dashboardId}`), []);
    return {
        column: {
            title: i18n.t('dashboards.nameTable'),
            dataIndex: '',
            className: 'remove-border',
            columnKey: 'name',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            defaultSortOrder: order?.columnKey === 'name' ? order.order : undefined,
            render: (dashboard: Dashboard) => (
                <StyledSpan
                    onClick={() => {
                        handleOnDashboardClick(dashboard.id);
                    }}
                >
                    {dashboard.name}
                </StyledSpan>
            ),
        },
    };
};
